import {VGMap} from "../../../../../modules/index.esm";

function onReady() {
	let $maps = document.querySelectorAll('[data-vg-map]');

	if ($maps.length) {
		for (let $map of $maps) {
			VGMap.init($map);
		}
	}

	VGMap.init('yaMapHome', {
		callback: {
			afterInitMap: function (map, params, _this) {
				VGMapCustom.run(map, params, _this);
			}
		}
	})
}

const VGMapCustom = {
	run: function (map, params, self) {

		let $pointList = document.querySelectorAll('[data-toggle="map"]'),
			points = self.PlaceMark.set(map, params);

		map.setZoom(13);

		points.forEach(function (placeMark, i) {
			placeMark.events.add('click', function (e) {
				let target = e.get('target'),
					coordinates = target.geometry._coordinates;

				map.setCenter(coordinates, 17);

				if ($pointList.length) {
					$pointList.forEach(function (point, n) {
						point.classList.remove('active');

						if (i === n) {
							point.classList.add('active');
						}
					});
				}
			});
		});

		if ($pointList.length) {
			$pointList.forEach(function (point, i) {
				point.onclick = function () {
					$pointList.forEach((item) => item.classList.remove('active'));
					this.classList.add('active');

					let coordinates = this.dataset.coord;
					if (coordinates) {
						coordinates = coordinates.split(',');
						map.setCenter(coordinates, 17);
						self.Map.offset(map, params);
					}

					return false;
				};
			});
		}


		let position = map.getGlobalPixelCenter();
		map.setGlobalPixelCenter([position[0], position[1] - 50]);
	},
}

document.addEventListener("DOMContentLoaded", onReady);
